import { CustomerType } from '@/redux/data/dataTypes';
import api from '../axios/axiosInstance';

const getCustomers = async (): Promise<CustomerType[]> => {
  const response = await api.get('/customers');
  return response.data;
};

export default getCustomers;
